var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAmtDot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 6C0 2.68629 2.68629 0 6 0C9.31234 0.00330738 11.9967 2.68766 12 6C12 9.31371 9.31371 12 6 12C2.68629 12 0 9.31371 0 6ZM3 6C3 7.65685 4.34315 9 6 9C6.79565 9 7.55871 8.68393 8.12132 8.12132C8.68393 7.55871 9 6.79565 9 6C9 4.34315 7.65685 3 6 3C4.34315 3 3 4.34315 3 6Z",
    fill: "#1A4840"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmtDot);
export default __webpack_public_path__ + "static/media/amtDot.838748f087a6aee5071fff0094e86483.svg";
export { ForwardRef as ReactComponent };